module.exports = __webpack_public_path__ + "static/hacienda_datos-8265b17e67a16518325db451d235e63f.jpg";